export default __webpack_public_path__ + "static/media/vehicle.45f0fad9.svg";